import { combineSlices } from '@reduxjs/toolkit'
import { authApi } from 'api/authApi'
import coverageTypeApi from 'api/coverageTypeApi'
import coverageBenefitApi from 'api/coverageBenefitApi'
import coverageRateApi from 'api/coverageRateApi'
import planApi from 'api/planApi'
import enumsApi from 'api/enumsApi'
import enquiryApi from 'api/enquiryApi'
import insuranceProductApi from 'api/insuranceProductApi'
import vehicleDetailsSearchApi from 'api/vehicleDetailsSearchApi'
import registrationSlice from 'pages/register/registrationSlice'
import insuranceCategorySlice from 'pages/insuranceProduct/insuranceProductSlice'
import planSelectionSlice from 'pages/plan/planSelectionSlice'
import usersApi from 'api/userApi'
import quotationApi from 'api/quotationApi'
import applicationApi from 'api/applicationApi'
import dashboardApi from 'api/dashboardApi'
import profileApi from 'api/profileApi'
import payoutApi from 'api/payoutApi'
import underwriterApi from 'api/underwriterApi'
import { auditApi } from 'api/auditApi'
import ipBlocksApi from 'api/ipBlocksApi'
import loginAttemptsApi from 'api/loginAttemptsApi'
import accountPrivacyApi from 'api/accountPrivacyApi'
import ngaoApi from 'api/ngaoApi'
import settingsApi from 'api/settingsApi'

const rootReducer = combineSlices(
  coverageTypeApi,
  coverageBenefitApi,
  coverageRateApi,
  planApi,
  authApi,
  enumsApi,
  profileApi,
  usersApi,
  insuranceProductApi,
  vehicleDetailsSearchApi,
  quotationApi,
  applicationApi,
  dashboardApi,
  payoutApi,
  underwriterApi,
  auditApi,
  ipBlocksApi,
  enquiryApi,
  loginAttemptsApi,
  accountPrivacyApi,
  ngaoApi,
  settingsApi,
  registrationSlice,
  insuranceCategorySlice,
  planSelectionSlice
)

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
